import './control-group.scss';

interface Props {
    children: React.ReactNode
}

const ControlGroup: React.FC<Props> = ({ children }) => {
    return (
        <div className={`control-group`}>
            {children}
        </div>
    );
}

export default ControlGroup;